'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ThreadedChatAreaContainer = require('../threads/containers/ThreadedChatAreaContainer');

var _ThreadedChatAreaContainer2 = _interopRequireDefault(_ThreadedChatAreaContainer);

var _MeetingsLinkContainer = require('../meetings-links/containers/MeetingsLinkContainer');

var _MeetingsLinkContainer2 = _interopRequireDefault(_MeetingsLinkContainer);

var _VisitorWidgetContainer = require('../visitor-widget/containers/VisitorWidgetContainer');

var _VisitorWidgetContainer2 = _interopRequireDefault(_VisitorWidgetContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThreadView = function (_Component) {
  _inherits(ThreadView, _Component);

  function ThreadView() {
    _classCallCheck(this, ThreadView);

    return _possibleConstructorReturn(this, (ThreadView.__proto__ || Object.getPrototypeOf(ThreadView)).apply(this, arguments));
  }

  _createClass(ThreadView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _VisitorWidgetContainer2.default,
        {
          browserWindowHeight: this.props.browserWindowHeight,
          isOpen: this.props.isOpen,
          launcherRef: this.props.launcherRef,
          onUpdateOpened: this.props.onUpdateOpened,
          onUpdateSize: this.props.onUpdateSize,
          viewingThreadList: false,
          inline: this.props.inline
        },
        _react2.default.createElement(_MeetingsLinkContainer2.default, null),
        _react2.default.createElement(_ThreadedChatAreaContainer2.default, null)
      );
    }
  }]);

  return ThreadView;
}(_react.Component);

ThreadView.propTypes = {
  browserWindowHeight: _react.PropTypes.number.isRequired,
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool,
  launcherRef: _react.PropTypes.object,
  onUpdateOpened: _react.PropTypes.func.isRequired,
  onUpdateSize: _react.PropTypes.func.isRequired
};

ThreadView.defaultProps = {
  browserWindowHeight: 0,
  onUpdateOpened: function onUpdateOpened() {},
  onUpdateSize: function onUpdateSize() {}
};

exports.default = ThreadView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/ThreadView.js
// module id = 1059
// module chunks = 2 3